import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import config from "config.js";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";

import EditIcon from "@material-ui/icons/Edit";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import ContractHTML from "./ContractHTML.jsx";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

// @material-ui/icons
import Check from "@material-ui/icons/Check";
import Button from "common/components/CustomButtons/Button.jsx";
import TextField from "@material-ui/core/TextField";
import FormGroup from "@material-ui/core/FormGroup";

import { isWebDevice } from "../../deviceInfo";

// core components
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const importedStyle = dashboardStyle;
const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: { ...importedStyle.cardTitle, margin: "30px", padding: "20px" },
  cardIconTitle: importedStyle.cardIconTitle,
  stats: importedStyle.stats,
  ...regularFormsStyle,
  termsText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "justify",
    border: "2px solid black",
    padding: "15px",
    width: "100%",
  },
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center",
  },
  inputAdornmentIcon: {
    color: "#555",
  },
  inputAdornment: {
    position: "relative",
  },
  errorMessage: {
    color: "red",
  },
  label: {
    color: "black",
  },
  contactInfo: {
    margin: "20px",
  },
  formGroup: {
    alignItems: "center",
  },
  checkboxAndRadio: {
    margin: "20px",
  },
  buttonStyle: {
    margin: "20px",
  },
};

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
function daysuffix(day) {
  if (day === 1) {
    return "st";
  }
  if (day === 2) {
    return "nd";
  }
  if (day === 3) {
    return "rd";
  }
  return "th";
}

const Signature = (props) => {
  const ids = useSelector((state) => state.services.ids);
  const [showmessage, setShowmessage] = useState(false);
  const [textfieldWidth, setTextfieldWidth] = useState();
  const contractTemplateOptions = Array.isArray(props.contractTemplateOptions)
    ? props.contractTemplateOptions
    : [];

  const date = new Date();
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  useEffect(() => {
    const getTextfieldWidth = async () => {
      const isWebResponse = await isWebDevice();
      if (isWebResponse) {
        setTextfieldWidth("30vw");
      } else {
        setTextfieldWidth("60vw");
      }
    };
    getTextfieldWidth();
  }, []);

  function handleFreeTermClick() {
    props.setTerm(1);
    props.setContractTemplateId("");
  }

  function handleMonthTermClick() {
    props.setTerm(2);
    props.setContractTemplateId("");
  }

  function handleContractTemplateOptionClick(option) {
    props.setTerm(Number(option.term));
    props.setContractTemplateId(option.id);
  }

  function showContract() {
    if (props.contractResign && props.contractResignType) {
      if (
        props.contractResignType === "NEEDDOC_CONTRACTNEW" ||
        props.contractResignType === "NEEDDOC_CONTRACTVER" ||
        props.contractResignType === "NEEDDOC_CONTRACTASSUME"
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  function isCompany() {
    if (props.type === "m" || props.type === "p") {
      return false;
    } else {
      return true;
    }
  }

  function getName1Label() {
    if (props.type === "m" || props.type === "p") {
      return "Full Legal Name";
    } else {
      return "Company Name    ";
    }
  }

  function getName2Label() {
    if (isCompany()) {
      return "Full Legal Name";
    }
  }

  function handleAgree() {
    if (
      props.contractResign &&
      props.contractResignType &&
      (props.contractResignType === "NEEDDOC_CONTRACTVER" ||
        props.contractResignType === "NEEDDOC_CONTRACTASSUME")
    ) {
      setShowmessage(false);
      props.goToSignaturePad();
      return;
    }
    if (
      props.term === 0 ||
      (contractTemplateOptions.length > 0 && !props.contractTemplateId)
    ) {
      setShowmessage(true);
    } else {
      props.goToSignaturePad();
    }
  }

  const { classes } = props;
  return (
    <GridContainer justify="center">
      <GridItem xs={12} md={10}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <EditIcon />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Contract</h4>
          </CardHeader>
          <CardBody>
            {showContract() && <ContractHTML />}
            {props.showContractTermAgreements() && (
              <GridContainer className={classes.termsText} align="center">
                <GridItem xs={12}>
                  <div className={classes.contactInfo}>
                    <br />
                    <h3>
                      <font color="blue">
                        {props.selectionLocked
                          ? "Your selected internet agreement"
                          : "Specific terms for Internet Installation (Please choose)"}
                      </font>
                    </h3>
                  </div>
                </GridItem>
                {props.selectionLocked ? (
                  <GridItem xs={12}>
                    <div className={classes.contactInfo}>
                      <p>
                        <strong>
                          {contractTemplateOptions.find(
                            (option) =>
                              String(option.id) ===
                              String(props.contractTemplateId)
                          )?.description || "Your saved internet plan"}
                        </strong>
                      </p>
                      <p>
                        This agreement follows the plan and prices you reviewed
                        in your package selection.
                      </p>
                      <Link
                        to={
                          config.MYACCOUNT.APP_PATH + "/user/preinstallpackage"
                        }
                      >
                        Review or change your plan
                      </Link>
                    </div>
                  </GridItem>
                ) : contractTemplateOptions.length > 0 ? (
                  contractTemplateOptions.map((option) => (
                    <GridItem key={option.id} xs={12} sm={6}>
                      <div className={classes.checkboxAndRadio}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              tabIndex={-1}
                              checked={
                                String(props.contractTemplateId) ===
                                String(option.id)
                              }
                              onClick={() =>
                                handleContractTemplateOptionClick(option)
                              }
                              checkedIcon={
                                <Check className={classes.checkedIcon} />
                              }
                              icon={<Check className={classes.uncheckedIcon} />}
                              classes={{
                                checked: classes.checked,
                                root: classes.checkRoot,
                              }}
                            />
                          }
                          classes={{
                            label: classes.label,
                          }}
                          label={
                            option.description ||
                            (Number(option.term) === 1
                              ? "FREE Standard Install 2 year term"
                              : "$199.95 Standard Install Month-to-month term")
                          }
                        />
                      </div>
                    </GridItem>
                  ))
                ) : (
                  <>
                    <GridItem xs={12} sm={6}>
                      <div className={classes.checkboxAndRadio}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              tabIndex={-1}
                              checked={props.term === 1}
                              onClick={handleFreeTermClick}
                              checkedIcon={
                                <Check className={classes.checkedIcon} />
                              }
                              icon={<Check className={classes.uncheckedIcon} />}
                              classes={{
                                checked: classes.checked,
                                root: classes.checkRoot,
                              }}
                            />
                          }
                          classes={{
                            label: classes.label,
                          }}
                          label="FREE Standard Install 2 year term"
                        />
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                      <div className={classes.checkboxAndRadio}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              tabIndex={-1}
                              checked={props.term === 2}
                              onClick={handleMonthTermClick}
                              checkedIcon={
                                <Check className={classes.checkedIcon} />
                              }
                              icon={<Check className={classes.uncheckedIcon} />}
                              classes={{
                                checked: classes.checked,
                                root: classes.checkRoot,
                              }}
                            />
                          }
                          classes={{
                            label: classes.label,
                          }}
                          label="$199.95 Standard Install Month-to-month term"
                        />
                      </div>
                    </GridItem>
                  </>
                )}
              </GridContainer>
            )}
            <GridContainer align="center" justify="center">
              {props.isNameChange() && (
                <GridItem xs={12}>
                  <FormGroup className={classes.formGroup}>
                    <TextField
                      style={{ width: textfieldWidth }}
                      label={getName1Label()}
                      defaultValue={props.name}
                      onChange={(event) => {
                        props.setName(event.target.value);
                      }}
                    ></TextField>
                    &nbsp;&nbsp;
                    {isCompany() && (
                      <TextField
                        style={{ width: textfieldWidth }}
                        label={getName2Label()}
                        defaultValue={props.name2}
                        onChange={(event) => {
                          props.setName2(event.target.value);
                        }}
                      ></TextField>
                    )}
                  </FormGroup>
                </GridItem>
              )}
            </GridContainer>
            <GridContainer align="center">
              {!props.isNameChange() && (
                <GridItem xs={12}>
                  <h5>
                    <strong>
                      I have read, understood and agree to be bound by the
                      MCSnet Subscriber Contract - Version 2.3. I further agree
                      to assume the remaining responsibility and obligations
                      associated with Contact ID #{ids.user} as of the date of
                      signing.
                    </strong>
                  </h5>
                  <br />
                </GridItem>
              )}
              {showmessage ? (
                <GridItem xs={12}>
                  <p>
                    <font color="red">
                      You need to choose between the two term options to proceed
                    </font>
                  </p>
                </GridItem>
              ) : null}

              <GridItem xs={12}>
                <Button
                  className={classes.buttonStyle}
                  color="primary"
                  onClick={handleAgree}
                >
                  CLICK HERE TO SIGN
                </Button>
              </GridItem>
              <GridItem xs={12}>
                <h5>
                  <strong>______________________</strong>
                </h5>
                <br />
              </GridItem>

              <GridItem xs={12}>
                <div className={classes.contactInfo}>
                  {!props.isNameChange() &&
                    (props.type === "c" ? (
                      <>
                        <h5>Company Name: {props.name}</h5>
                        <h5>Authorized Signer: {props.name2}</h5>
                      </>
                    ) : (
                      <h5>Name: {props.name}</h5>
                    ))}
                  <h5>Date: {`${month} ${day}${daysuffix(day)}, ${year}`}</h5>
                  <h5>Customer Number: {ids.user}</h5>
                  <h5>Electronically signed from identity: {ids.email}</h5>
                  <h5>IP address: {props.ip}</h5>
                </div>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default withStyles(styles)(Signature);
